<p-toast [style]="{marginTop: '41vh'}" position="top-center" key="maecargos"></p-toast>
<p-confirmDialog [transitionOptions]="'0ms'" key="MaeCargos" title="Confirmar Acción"
				 appendTo="body"></p-confirmDialog>


<div class="p-grid" style="width: 99%">
	<div class="p-col-12">
		<app-invmaebarra [botonNuevo]="btnNuevo" [botonGuardar]="btnGuardar" [botonBorrar]="btnBorrar"
						 [botonRegresar]="btnRegresar" [barraBotonesCRUD]="false"
						 [barraBotonesDesplaz]="true" [barraBotones3]="true" [barraBotonesAsiCon]="true"
						 [barraBotones5]="true"
						 (signal)="manejarSenales($event)"></app-invmaebarra>
	</div>

</div>

<div style="overflow: hidden" class="p-col-12">
	<p-tabView>
		<p-tabPanel header="Datos">
			<p-scrollPanel [style]="{'width':'100%', 'height':'calc(100vh - 260px)'}">
				<app-aggridsaci [width]=""
								[height]="largo"
								[enableSorting]="false"
								[enableFilter]="true"
								[rowData]="cargoService.commaecargos"
								[frameworkComponents]="frameworkComponents"
								[animateRows]="true"
								[rowSelection]="rowSelection"
								[columnDefs]="columnDefsCargos"
								[defaultColDef]="defaultColDefCargos"
								[rowStyle]="rowStyle"
								[singleClickEdit]="false"
								[botones]="false"
								(selected)="selectedCargo($event)"
								(cambios)="cambio($event)"

				></app-aggridsaci>
			</p-scrollPanel>
		</p-tabPanel>
	</p-tabView>
</div>
